import React, { useState } from 'react';
import env from '../../environment';
import GeoJSON from 'geojson';
import tokml from 'tokml';
import download from 'downloadjs';
import { fixEncoding } from '../../utils/fixEncoding.js';
import BlockUi from 'react-block-ui';
import useEtiquetas from '../../hooks/useEtiquetas'
import transformWord from '../../utils/transformWord'

const ModalKMLDownload = ({ isOpen, onClose, dataForKML, parcelaId = 'padron', parcelaName = '', blocking = false }) => {
  const [selectedFormat, setSelectedFormat] = useState('kml');
  const [withPersonalData, setWithPersonalData] = useState(false);
  const [withPolygons, setWithPolygons] = useState(true);
  const { etiquetas } = useEtiquetas();

  if (!isOpen) return null;

  const handleDownload = () => {
    // Create a modified version of descargaKML that accepts a custom filename
    const downloadFile = (data, format, withPersonalData) => {

      const transformGeoData = _dataProductores => {
        let _polygon = [];
        const cleanData = [];
        for (let index = 0; index < _dataProductores.length; index++) {
          const item = {};
          const currentData = _dataProductores[index];
          
          // Helper function to add non-null values
          const addIfNotNull = (key, value) => {
            if (value !== null && value !== undefined && value !== '') {
              item[key] = value;
            }
          };
          if (withPersonalData) {
            addIfNotNull('parcela_nombre', fixEncoding(currentData.parcela_nombre));
            addIfNotNull('productor_nombre', fixEncoding(currentData.productor_nombre));
          }
          addIfNotNull('id_parcela', fixEncoding(currentData.id_parcela));
          addIfNotNull('codigo', fixEncoding(currentData.codigo));
          addIfNotNull('parcela_uuid', fixEncoding(currentData.parcela_uuid));
          addIfNotNull('productor_clave', fixEncoding(currentData.productor_clave));
          addIfNotNull('productor_codigo', fixEncoding(currentData.productor_codigo));
          const superficie = currentData.poligono_area && withPolygons ? currentData.poligono_area : currentData.parcela_superficie;
          addIfNotNull('parcela_superficie', fixEncoding(superficie));
          addIfNotNull('localidad', fixEncoding(currentData.localidad));
          addIfNotNull('municipio', fixEncoding(currentData.municipio));
          addIfNotNull('pais', fixEncoding(currentData.pais));
          addIfNotNull('categoria', fixEncoding(currentData.cuenta_categoria));
          // Handle polygon data
          if (currentData.poligono && withPolygons) {
            try {
              _polygon = JSON.parse(currentData.poligono);
              if (_polygon !== null && _polygon.coordinates) {
                item.poligono = _polygon.coordinates;
              }
            } catch (error) {
              console.warn('Error parsing polygon data:', error);
            }
          }
          
          // Handle centroid data
          if (currentData.centroide_lat !== null && currentData.centroide_lat !== undefined && 
              currentData.centroide_lng !== null && currentData.centroide_lng !== undefined) {
            item.punto = [currentData.centroide_lng, currentData.centroide_lat];
          }
          
          if (item.punto !== undefined || item.poligono !== undefined) {
            cleanData.push(item);
          }
        }
        return cleanData;
      };

      GeoJSON.parse(
        transformGeoData(data),
        {
          Point: 'punto',
          Polygon: 'poligono',
          removeInvalidGeometries: true,
        },
        function(geojsonObject) {
          const filename = withPersonalData ? `${parcelaName}_${parcelaId}` : parcelaId ;
          if (format === 'kml') {
            let kmlNameDescription = tokml(geojsonObject, {
              name: withPersonalData ? 'parcela_nombre' : 'id_parcela',
              documentName: parcelaId === 'padron' ?
                `Listado de ${transformWord(etiquetas?.parcela, ['plural','lowercase'])}`
                : filename,
              documentDescription: parcelaId === 'padron'
                ? `Listado de ${transformWord(etiquetas?.parcela, ['plural','lowercase'])} de la cooperativa`
                : filename,
            });
            download(kmlNameDescription, `${parcelaId === 'padron' ? 'padron' : filename}.kml`);
          } else if (format === 'geojson') {
            const geojsonString = JSON.stringify(geojsonObject, null, 2);
            const blob = new Blob([geojsonString], { type: 'application/json' });
            download(blob, `${parcelaId === 'padron' ? 'padron' : filename}.geojson`);
          }
        }
      );
    };

    downloadFile(dataForKML, selectedFormat, withPersonalData);
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1060,
      }}
      onClick={onClose}
    >
      <BlockUi
        message=""
        blocking={blocking}
        renderChildren={false}
        style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '10px',
          minWidth: '350px',
          textAlign: 'center',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ marginBottom: '20px' }}>
          <img src={env.images.icon.kml} alt="KML Icon" style={{ marginRight: '10px' }} />
          <h4 style={{ margin: 0, color: '#333' }}>Descargar Mapa</h4>
        </div>

        {/* Format Selection */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '10px', fontWeight: '500', color: '#333', fontWeight: 'bold' }}>
            Formato de archivo:
          </label>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="format"
                value="kml"
                checked={selectedFormat === 'kml'}
                onChange={(e) => setSelectedFormat(e.target.value)}
                style={{ marginRight: '5px' }}
              />
              KML
            </label>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="format"
                value="geojson"
                checked={selectedFormat === 'geojson'}
                onChange={(e) => setSelectedFormat(e.target.value)}
                style={{ marginRight: '5px' }}
              />
              GeoJSON
            </label>
          </div>
        </div>

        {/* Data Options */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '10px', fontWeight: '500', color: '#333', fontWeight: 'bold' }}>
            Opciones de datos:
          </label>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="dataType"
                value={false}
                checked={!withPersonalData}
                onChange={(e) => setWithPersonalData(e.target.value === 'true')}
                style={{ marginRight: '5px' }}
              />
              Ocultando datos personales
            </label>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="dataType"
                value={true}
                checked={withPersonalData}
                onChange={(e) => setWithPersonalData(e.target.value === 'true')}
                style={{ marginRight: '5px' }}
              />
              Todos los datos
            </label>
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '6px' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="withPolygons"
                value={true}
                checked={withPolygons}
                onChange={(e) => setWithPolygons(e.target.value === 'true')}
                style={{ marginRight: '5px' }}
              />
              Polígonos y centroides
            </label>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="withPolygons"
                value={false}
                checked={!withPolygons}
                onChange={(e) => setWithPolygons(e.target.value === 'true')}
                style={{ marginRight: '5px' }}
              />
              Sólo centroides
            </label>
          </div>
        </div>

        {/* Download Button */}
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <button
            onClick={handleDownload}
            style={{
              padding: '12px 24px',
              backgroundColor: env.colors.primary_500,
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'background-color 0.2s',
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = env.colors.primary_300}
            onMouseOut={(e) => e.target.style.backgroundColor = env.colors.primary_500}
          >
            Descargar {selectedFormat.toUpperCase()}
          </button>
        </div>
        
        <button
          onClick={onClose}
          style={{
            marginTop: '20px',
            padding: '8px 16px',
            backgroundColor: '#f8f9fa',
            color: '#666',
            border: '1px solid #ddd',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px',
          }}
        >
          Cancelar
        </button>
      </BlockUi>
    </div>
  );
};

export default ModalKMLDownload;
